var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPasswordClosed = function SvgIconPasswordClosed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "nonzero",
    d: "M8.997 1.542c-3.438 0-6.556 1.881-8.856 4.936a.712.712 0 0 0 0 .85c2.3 3.06 5.418 4.94 8.856 4.94 3.438 0 6.556-1.88 8.857-4.936a.712.712 0 0 0 0-.85c-2.3-3.059-5.419-4.94-8.857-4.94zm.247 9.14A3.787 3.787 0 0 1 5.22 6.66a3.793 3.793 0 0 1 3.53-3.53 3.787 3.787 0 0 1 4.023 4.023 3.805 3.805 0 0 1-3.53 3.53zM9.13 8.937a2.035 2.035 0 0 1-2.165-2.164A2.047 2.047 0 0 1 8.868 4.87a2.035 2.035 0 0 1 2.165 2.164A2.047 2.047 0 0 1 9.13 8.937z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B5C4",
    strokeLinecap: "round",
    d: "M6 14.135L12.545 0"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPasswordClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-password-closed.a7ef6250.svg";
export { ForwardRef as ReactComponent };